import { es, nl, nlBE, enUS, enIE, enGB, de, it, ptBR, pt } from "react-day-picker/locale";

const localeMap = {
  "nl-NL": nl,
  "nl-BE": nlBE,
  "en-GB": enGB,
  "en-IE": enIE,
  "en-US": enUS,
  "de-DE": de,
  "it-IT": it,
  "es-ES": es,
  "pt-BR": ptBR,
  "pt-PT": pt
}

// Check to make sure all locales are supported
serverReference.interfaceCultures.forEach(culture => {
  if (!localeMap[culture.locale]) {
    console.error(`Locale ${culture.locale} is not configured for react-day-picker`);
  }
});

export default (uiLocale: string): any => {
  return localeMap[uiLocale] ?? enUS;
}